const Dotted = (props?: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M8.00501 3.00793V3.01507M10.5047 3.67747L10.5011 3.68461M12.3356 5.50764L12.3285 5.51121M13.0051 8.00735H12.998M12.3356 10.5071L12.3292 10.5035M10.5054 12.3379L10.5019 12.3308M8.00501 13.0011V13.0082M5.50816 12.3322L5.50459 12.3387M3.68085 10.5042L3.67514 10.5078M3.01202 8.00806H3.00488M3.68085 5.51121L3.67514 5.50764M5.50816 3.6839L5.50459 3.67819"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default Dotted;
